/** ตัวช่วยจัดรูปแบบข้อความสำหรับแสดงผล */
import { CAPTURE_STATUS_LABELS_TH, type CaptureStatus } from '../../shared/types';

export function statusPillClass(status: CaptureStatus): string {
  switch (status) {
    case 'completed':
      return 'pill pill-ok';
    case 'failed':
      return 'pill pill-bad';
    case 'void':
      return 'pill pill-muted';
    case 'uploading':
      return 'pill pill-info';
    default:
      return 'pill pill-warn';
  }
}

export function statusLabel(status: CaptureStatus): string {
  return CAPTURE_STATUS_LABELS_TH[status] ?? status;
}

export function metres(value: number): string {
  return `${value < 10 ? value.toFixed(1) : Math.round(value)} ม.`;
}

export function coordinate(value: number): string {
  return value.toFixed(6);
}
